import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { gatewaySessionTokenReducer } from './gateway-session-token.reducer';

@NgModule({
  imports: [StoreModule.forFeature('gatewaySessionToken', gatewaySessionTokenReducer)],
})
export class GatewaySessionTokenModule {}
